import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Svg } from "assets";
import { ButtonMain } from "components";
import { httpRequestsOnSuccessActions } from "store";
import { FindLoad, FindSuccess, useModal } from "utils";

export const DeleteModal = ({
  actionType,
  handleDelete,
  handleCancel,
  title,
  description,
  afterSuccess,
  customIcon,
  buttonMainStyles,
}) => {
  const dispatch = useDispatch();
  const { close } = useModal();
  const success = FindSuccess(actionType);
  const loading = FindLoad(actionType);

  useEffect(() => {
    if (success) {
      if (afterSuccess) {
        afterSuccess();
      } else {
        close();
      }

      dispatch(httpRequestsOnSuccessActions.removeSuccess(actionType));
    }
  }, [success]);

  return (
    <div className="delete-modal">
      {customIcon ? customIcon : <Svg.DeleteModalSvg />}
      <div>
        <p className="delete-modal-title">{title}</p>
        <p className="delete-modal-desc">{description}</p>
      </div>
      <div
        className="flex-end"
        style={{ gap: 8, marginTop: 16, paddingTop: 8 }}
      >
        <ButtonMain
          cancel
          text="No"
          onClick={() => {
            if (handleCancel) {
              handleCancel();
            } else {
              close();
            }
          }}
        />
        <ButtonMain
          classNameWrapper="delete-modal-btn"
          buttonMainStyles={buttonMainStyles}
          actionTye={actionType}
          text="Yes"
          type="button"
          onClick={handleDelete}
          load={!!loading?.length}
        />
      </div>
    </div>
  );
};
